import { render, staticRenderFns } from "./lastPosts.vue?vue&type=template&id=53f87da0&scoped=true&"
import script from "./lastPosts.vue?vue&type=script&lang=ts&"
export * from "./lastPosts.vue?vue&type=script&lang=ts&"
import style0 from "./lastPosts.vue?vue&type=style&index=0&id=53f87da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f87da0",
  null
  
)

export default component.exports